import type * as ReduxHelpers from './'
import { createAction as createActionRedux } from '@reduxjs/toolkit'

export const createAction = <Type extends string, Meta>(
  type: Type,
  meta?: Meta
): ReduxHelpers.Types.ARedux<Type, Meta> => ({ type, meta })

export const createPayloadAction = <Type extends string, Payload>(
  type: Type,
  payload: Payload
): ReduxHelpers.Types.PayloadAction<Payload, Type> => ({
  ...createActionRedux(type),
  payload
})
